import Checkbox from 'src/components/primitives/Checkbox/Checkbox';
import Env from 'src/environmentVariables/EnvironmentVariables';
import InlineAlert from 'src/components/primitives/InlineAlert/InlineAlert';

export default function PriceDivergenceWarningMessage({
	hasAgreedToPriceDivergence,
	setHasAgreedToPriceDivergence,
	priceDivergencePct,
}: {
	hasAgreedToPriceDivergence: boolean;
	setHasAgreedToPriceDivergence: React.Dispatch<React.SetStateAction<boolean>>;
	priceDivergencePct?: string;
}) {
	return (
		<InlineAlert title="Price Divergence" variant="warning">
			<span>
				{`Est. entry price is ${
					priceDivergencePct ?? `>${Env.priceDivergenceWarningThreshold}`
				}% from oracle price. Proceeding with this order may result in poor fills.`}
			</span>

			<Checkbox.Default
				id="price-divergence-warning-message"
				className="mt-1 text-text-default"
				label="I understand the risk"
				checked={hasAgreedToPriceDivergence}
				onCheckedChange={() => {
					setHasAgreedToPriceDivergence((prev) => !prev);
				}}
			/>
		</InlineAlert>
	);
}
